<script>
	import { Button, Col, Row } from "sveltestrap";
	import { field, form } from "svelte-forms";
	import ErrorMessageHandler from "../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import Loader from "../../components/Loader/Loader.svelte";
	import PageHeader from "../../components/PageHeader/PageHeader.svelte";
	import client from "../../services/client";
	import {
		errorMessage,
		loading,
		masterData,
		warningModalOpen,
		evMasterData,
	} from "../../store/store";
	import SveltyPicker from "svelty-picker";
	import { navigate } from "svelte-routing";
	import { carSeatOptions } from "../../utils/options";
	import { dynamicSort, extractErrorMessage } from "src/utils/misc";
	import { carDetail } from "../../store/store";
	import { required, min } from "svelte-forms/validators";
	import WarningModal from "../../components/CustomModal/WarningModal.svelte";
	import { convertSGDateOnly } from "../../services/helpers.ts";
	import { onDestroy, onMount } from "svelte";
	import LoaderContainer from "../../components/Loader/LoaderContainer.svelte";
	import CustomInput from "../../components/CustomInput/CustomInput.svelte";
	import CustomSelect from "../../components/CustomSelect/CustomSelect.svelte";
	import CustomSearch from "../../components/CustomSearch/CustomSearch.svelte";

	export let isEdit;

	onMount(async () => {
		await getEvMasterData();
		await fetchEfficiencyRates();
		if (isEdit) {
			emptyFieldFinders();
		}
	});

	onDestroy(() => {
		carDetail.set({});
	});

	const vehicleMakeId = field(
		"vehicleMakeId",
		isEdit ? $carDetail.vehicleMakeId : "",
		[required()]
	);
	const vehicleModelId = field(
		"vehicleModelId",
		isEdit ? $carDetail.vehicleModelId : "",
		[required()]
	);
	const numSeats = field("numSeats", isEdit ? $carDetail.numSeats : "", [
		required(),
	]);
	const vehicleFuelId = field(
		"vehicleFuelId",
		isEdit ? $carDetail.vehicleFuelId : "",
		[required()]
	);
	// const carType = field("carType", selectedType ? selectedType.id : "", [
	// 	required(),
	// ]);
	const bootSpace = field("bootSpace", isEdit ? $carDetail.bootSpace : "", [
		required(),
	]);
	const description = field(
		"description",
		isEdit ? $carDetail.description : "",
		[required()]
	);
	const iuNumber = field("iuNumber", isEdit ? $carDetail.iuNumber : "", [
		required(),
	]);
	const priceGroupId = field(
		"priceGroupId",
		isEdit ? $carDetail.priceGroupId : "",
		[required()]
	);
	const engineNumber = field(
		"engineNumber",
		isEdit ? $carDetail.engineNumber : "",
		[required()]
	);
	const vehicleColorId = field(
		"vehicleColorId",
		isEdit ? $carDetail.vehicleColorId : "",
		[required()]
	);
	const assetOwnerId = field(
		"assetOwnerId",
		isEdit ? $carDetail.assetOwnerId : "",
		[required()]
	);
	const lastServiceDate = field(
		"lastServiceDate",
		isEdit
			? $carDetail.lastServiceDate
				? convertSGDateOnly($carDetail.lastServiceDate)
				: ""
			: "",
		[]
	);
	const lastCleanedDate = field(
		"lastCleanedDate",
		isEdit
			? $carDetail.lastCleanedDate
				? convertSGDateOnly($carDetail.lastCleanedDate)
				: ""
			: "",
		[]
	);
	const activeFrom = field(
		"activeFrom",
		isEdit ? convertSGDateOnly($carDetail.activeFrom) : "",
		[required()]
	);
	const activeTo = field(
		"activeTo",
		isEdit ? convertSGDateOnly($carDetail.activeTo) : "",
		[required()]
	);

	const currentMileage = field(
		"currentMileage",
		isEdit ? $carDetail.currentMileage : "",
		[required()]
	);
	const currentFuelLevel = field(
		"currentFuelLevel",
		isEdit ? $carDetail.currentFuelLevel : "",
		[]
	);
	const lastServiceMileage = field(
		"lastServiceMileage",
		isEdit ? $carDetail.lastServiceMileage : "",
		[min(0)]
	);
	const stationId = field(
		"stationId",
		isEdit ? $carDetail.stationId : "",
		[]
	);

	const fuelEfficiency = field("fuelEfficiency", "", [required()]);
	// const maxEvDistance = field("maxEvDistance", "", [required()]);
	const fuelCapacity = field("fuelCapacity", "", [required()]);
	const plateNumber = field(
		"plateNumber",
		isEdit ? $carDetail.plateNumber : "",
		[required()]
	);
	const chassisNumber = field(
		"chassisNumber",
		isEdit ? $carDetail.chassisNumber : "",
		[required()]
	);
	const carPark = field(
		"carPark",
		isEdit
			? { value: $carDetail.carParkId, label: $carDetail.carParkName }
			: "",
		[required()]
	);

	const myForm = form(
		activeFrom,
		activeTo,
		vehicleMakeId,
		vehicleModelId,
		vehicleFuelId,
		vehicleColorId,
		description,
		plateNumber,
		iuNumber,
		chassisNumber,
		engineNumber,
		// fuelEfficiency,
		// fuelCapacity,
		numSeats,
		// maxEvDistance,
		bootSpace,
		carPark,
		assetOwnerId,
		priceGroupId,
		lastCleanedDate,
		lastServiceDate,
		currentMileage,
		currentFuelLevel,
		lastServiceMileage
	);

	$: filteredModel =
		$vehicleMakeId.value === ""
			? $masterData.vehicleModels
			: $masterData.vehicleModels.filter((model) => {
					return model.makeId == $vehicleMakeId.value;
			  });
	$: selectedModel = $masterData.vehicleModels.find(
		(model) => model.id == $vehicleModelId.value
	);
	$: typeCar = selectedModel ? selectedModel?.typeId : "";
	$: selectedType =
		$masterData.vehicleTypes.find((type) => type.id == typeCar) || "";
	$: type = selectedType ? selectedType.name : "Select type";
	$: typeInput = selectedType ? selectedType.id : "Select type";
	$: fuelTypes = $masterData.fuelTypes.find(
		(type) => type.id == $vehicleFuelId.value
	);

	let invalidModel;
	let duplicatePlateNo;
	let invalidCarpark;
	let efficiencyRates;

	//Function to find fuel capacity, max ev distance, and fuel efficiency value
	const emptyFieldFinders = async () => {
		let objects, foundObject;

		objects = [...$evMasterData.efficiencyRates, ...efficiencyRates];
		foundObject =
			objects.find(
				(item) =>
					item.vehicleMakeId === $vehicleMakeId.value &&
					item.vehicleModelId === $vehicleModelId.value
			) ||
			objects.find(
				(item) =>
					item.makeId === $vehicleMakeId.value &&
					item.modelId === $vehicleModelId.value
			);

		if (foundObject) {
			$fuelCapacity.value =
				foundObject.fuelTankSizeOrCapacity ?? foundObject.evMaxDistance;
			$fuelEfficiency.value =
				foundObject.fuelConsumptionOrEfficiency ??
				foundObject.efficiency;
		} else {
			$fuelCapacity.value = null;
			$fuelEfficiency.value = null;
		}
	};

	const getEvMasterData = async () => {
		try {
			loading.set(true);
			const res = await client("/v1/masterData", {
				method: "GET",
				version: "evCharging",
			});
			evMasterData.set(res.data.data);
			loading.set(false);
			return res;
		} catch (error) {
			console.log(error.response);
			loading.set(false);
			// errorMessage.set(error);
			return error;
		}
	};

	const fetchEfficiencyRates = async () => {
		try {
			loading.set(true);
			const res = await client(
				"/v1/fuel/efficiencyRate?Page=1&Size=100",
				{
					method: "GET",
					version: "Vehicle",
				}
			);
			efficiencyRates = res.data.dataList;
			loading.set(false);
		} catch (error) {
			console.log(error);
			loading.set(false);
		}
	};

	const stationIdOptions = $evMasterData?.evStationIds?.map((item) => {
		return {
			value: item.stationId.toString(),
			label: item.stationId,
		};
	});

	const carParkOptions = $masterData?.carParks?.sort(dynamicSort("name"));
	const loadOptions = carParkOptions.map((item) => {
		return {
			value: item.id,
			label: item.name,
		};
	});

	async function handleSubmit() {
		if (
			$fuelCapacity.value === null ||
			$fuelEfficiency.value === null
			// $maxEvDistance.value === null ||
			// false
		) {
			warningModalOpen.set(true);
		} else {
			loading.set(true);
			try {
				let data = {
					plateNumber: $plateNumber.value,
					vehicleMakeId: $vehicleMakeId.value,
					vehicleModelId: $vehicleModelId.value,
					vehicleTypeId: typeInput,
					numberOfSeats: parseInt($numSeats.value),
					fuelTypeId: $vehicleFuelId.value,
					bootSpace: $bootSpace.value,
					description: $description.value,
					iuNumber: $iuNumber.value,
					priceGroupId: $priceGroupId.value,
					carparkId: $carPark.value.value,
					chassisNumber: $chassisNumber.value,
					engineNumber: $engineNumber.value,
					vehicleColorId: $vehicleColorId.value,
					assetOwnerId: $assetOwnerId.value,
					lastServiceDate:
						$lastServiceDate.value == ""
							? null
							: new Date($lastServiceDate.value),
					lastCleanedDate:
						$lastCleanedDate.value == ""
							? null
							: new Date($lastCleanedDate.value),
					activeFrom: new Date($activeFrom.value),
					activeTo: new Date($activeTo.value),
					currentMileage: parseInt($currentMileage.value),
					currentFuelLevel: parseInt($currentFuelLevel.value),
					stationId: $stationId.value?.toString(),
					lastServiceMileage: parseInt($lastServiceMileage.value),
					telemetryProvider: $carDetail.telemetryProvider || 1,
				};

				if (isEdit) {
					data.id = parseInt(isEdit);
				}
				const res = await client("/v1", {
					method: isEdit ? "PUT" : "POST",
					version: "Vehicle",
					data,
				});

				if (res.status === 200) {
					navigate("/car-management");
				}
				loading.set(false);
			} catch (error) {
				extractErrorMessage(error);
				if (error.response.data.code === 22010) {
					navigate("/car-management");
				}
				loading.set(false);
			}
		}
	}

	let load = false;
	loading.subscribe((value) => {
		load = value;
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	$: isInvalid =
		!$activeFrom.value ||
		!$activeTo.value ||
		!$vehicleMakeId.value ||
		!$vehicleModelId.value ||
		!$vehicleFuelId.value ||
		!$vehicleColorId.value ||
		!$description.value ||
		!$plateNumber.value ||
		!$iuNumber.value ||
		!$chassisNumber.value ||
		!$engineNumber.value ||
		!$numSeats.value ||
		!$bootSpace.value ||
		!$carPark.value ||
		!$assetOwnerId.value ||
		!$priceGroupId.value;
</script>

<LoaderContainer>
	<Row>
		<Col>
			<div>
				<PageHeader
					title={isEdit ? "Update Car Details" : "Add New Car"}
				/>
				<ErrorMessageHandler message={err} />
				<Col>
					<Row>
						<Col>
							<label for="plateNumber" class="d-block">
								<span> <b>Car Plate No.*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={2}>
							<CustomInput
								type="text"
								bind:value={$plateNumber.value}
								validate={required()}
								error={$myForm.hasError(
									"plateNumber.required"
								) || duplicatePlateNo}
								errorText={$myForm.hasError(
									"plateNumber.required"
								)
									? "Car plate number is required"
									: duplicatePlateNo
									? "This plate number is already added"
									: ""}
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="priority" class="d-block mt-3">
								<span> <b>Car Make*</b></span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomSelect
								bind:value={$vehicleMakeId.value}
								type="text"
								bind:options={$masterData.vehicleMakes}
								error={$myForm.hasError(
									"vehicleMakeId.required"
								)}
								errorText="Car make is required"
								defaultOption="Select car make"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="vehicleModelId" class="d-block mt-3">
								<span> <b>Car Model* </b></span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomSelect
								bind:value={$vehicleModelId.value}
								type="text"
								options={filteredModel}
								error={$myForm.hasError(
									"vehicleModelId.required"
								) || invalidModel}
								errorText={$myForm.hasError(
									"vehicleModelId.required"
								)
									? "Car model is required"
									: invalidModel
									? "Invalid model"
									: ""}
								defaultOption="Select car model"
								onChange={() => {
									invalidModel = "";
									emptyFieldFinders();
								}}
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="carType" class="d-block mt-3">
								<span> <b>Car Type* </b></span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomInput
								type="text"
								placeholder={selectedType
									? selectedType.name
									: "Select car type"}
								error={$myForm.hasError("carType.required")}
								errorText="Car type is required"
								disabled={true}
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="numSeats" class="d-block mt-3">
								<span> <b>No. of Seats*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={2}>
							<CustomSelect
								bind:value={$numSeats.value}
								type="text"
								options={carSeatOptions}
								error={$myForm.hasError("numSeats.required")}
								errorText="No. of seats is required"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="vehicleFuelId" class="d-block mt-3">
								<span> <b>Fuel Type*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<div>
								{#each $masterData.fuelTypes as { id, name }, key}
									<label
										key={`option-${name}-${key + 1}`}
										class="customCheckbox"
									>
										<input
											type="radio"
											{name}
											value={id}
											class="d-none input"
											bind:group={$vehicleFuelId.value}
										/>
										<span
											class="customCheckbox__content mt-2"
										>
											{name}
										</span>
									</label>
								{/each}
								{#if $myForm.hasError("vehicleFuelId.required")}
									<div>
										<p class="error-text">
											Fuel Type is required
										</p>
									</div>
								{/if}
							</div>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="bootSpace" class="d-block mt-3">
								<span> <b>Boot Space.*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomInput
								type="text"
								bind:value={$bootSpace.value}
								validate={required()}
								error={$myForm.hasError("bootSpace.required")}
								errorText="Bootspace is required"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="description" class="d-block mt-3">
								<span> <b>Description*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomInput
								type="text"
								bind:value={$description.value}
								validate={required()}
								error={$myForm.hasError("description.required")}
								errorText="Description is required"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="iuNumber" class="d-block mt-3">
								<span> <b>IU Number*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomInput
								type="text"
								bind:value={$iuNumber.value}
								validate={required()}
								error={$myForm.hasError("iuNumber.required")}
								errorText="IU Number is required"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="chassisNumber" class="d-block mt-3">
								<span> <b>Chassis Number*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomInput
								type="text"
								bind:value={$chassisNumber.value}
								validate={required()}
								error={$myForm.hasError(
									"chassisNumber.required"
								)}
								errorText="Chasis Number is required"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="engineNumber" class="d-block mt-3">
								<span> <b>Engine Number*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomInput
								type="text"
								bind:value={$engineNumber.value}
								validate={required()}
								error={$myForm.hasError(
									"engineNumber.required"
								)}
								errorText="Engine Number is required"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="bodyColor" class="d-block mt-3">
								<span> <b>Body Color*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomSelect
								bind:value={$vehicleColorId.value}
								type="text"
								options={$masterData.vehicleColors}
								error={$myForm.hasError(
									"vehicleColorId.required"
								)}
								errorText="Body color is required"
								defaultOption="Select color"
							/>
						</Col>
					</Row>
				</Col>

				<Col>
					<Row>
						<Col>
							<label for="priceGroupId" class="d-block mt-3">
								<span> <b>Price Group*</b></span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<div>
								{#each $masterData.priceGroups as { id, name }, key}
									<label
										key={`option-${name}-${key + 1}`}
										class="customCheckbox mt-2"
									>
										<input
											type="radio"
											{name}
											value={id}
											class="d-none input"
											bind:group={$priceGroupId.value}
										/>
										<span class="customCheckbox__content">
											{name}
										</span>
									</label>
								{/each}
								{#if $myForm.hasError("priceGroupId.required")}
									<div>
										<p class="error-text">
											Price group is required
										</p>
									</div>
								{/if}
							</div>
						</Col>
					</Row>
				</Col>
				{#if $vehicleModelId.value !== "" && $vehicleMakeId.value !== "" && fuelTypes?.name === "Electric"}
					<Col>
						<Row>
							<Col>
								<label for="stationId" class="d-block mt-3">
									<span>
										<b>Station ID</b>
									</span>
								</label>
							</Col>
						</Row>
						<Row>
							<Col xs={6}>
								<!-- <CustomSelect
									bind:value={$stationId.value}
									type="text"
									options={stationIdOptions}
									error={$myForm.hasError(
										"stationId.required"
									)}
									defaultOption="Select Station ID"
								/> -->
								<CustomSearch
									bind:value={$stationId.value}
									items={stationIdOptions}
									error={$myForm.hasError(
										"stationId.required"
									)}
									placeholder="Select station ID"
								/>
							</Col>
						</Row>
					</Col>
				{/if}
				<Col>
					<Row>
						<Col>
							<label for="carPark" class="d-block mt-3">
								<span> <b>Carpark*</b></span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<!-- <CustomSelect
								bind:value={$carPark.value}
								type="text"
								options={loadOptions}
								error={$myForm.hasError("carPark.required") ||
									invalidCarpark}
								errorText={"Carpark is required" ||
									invalidCarpark}
								defaultOption={"Select Carpark"}
							/> -->
							<CustomSearch
								bind:value={$carPark.value}
								items={loadOptions}
								error={$myForm.hasError("carPark.required")}
								errorText="Carpark is required"
								placeholder="Select Carpark"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="assetOwnerId" class="d-block mt-3">
								<span> <b>Car Asset Owner*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomSelect
								bind:value={$assetOwnerId.value}
								type="text"
								options={$masterData.carAssetOwners}
								error={$myForm.hasError(
									"assetOwnerId.required"
								)}
								errorText="Car Asset owner is required"
								defaultOption="Select Car Asset Owner"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col xs={2}>
							<label for="lastCleanedDate" class="d-block mt-3">
								<span> <b>Last Cleaned</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={2}>
							<SveltyPicker
								inputClasses="form-control getgo input {new Date(
									$lastCleanedDate.value
								) > new Date()
									? 'border border-danger'
									: ''}"
								format="yyyy-mm-dd"
								placeholder="YYYY-MM-DD"
								bind:value={$lastCleanedDate.value}
							/>
							{#if new Date($lastCleanedDate.value) > new Date()}
								<div>
									<p class="error-text">
										Last cleaned date cannot be in the
										future
									</p>
								</div>
							{/if}
						</Col>
					</Row>
				</Col>

				<Col>
					<Row>
						<Col xs={2}>
							<label for="lastServicedate" class="d-block mt-3">
								<span> <b>Start Date*</b> </span>
							</label>
						</Col>
						<Col xs={2}>
							<label for="lastCleanedDate" class="d-block mt-3">
								<span> <b>End Date*</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={2}>
							<SveltyPicker
								inputClasses="form-control getgo input {$myForm.hasError(
									'activeFrom.required'
								)
									? 'border border-danger'
									: ''}"
								format="yyyy-mm-dd"
								placeholder="YYYY-MM-DD"
								bind:value={$activeFrom.value}
							/>
							{#if $myForm.hasError("activeFrom.required")}
								<div>
									<p class="error-text">
										Start date is required
									</p>
								</div>
							{:else if new Date($activeFrom.value) > new Date($activeTo.value)}
								<div>
									<p class="error-text">
										Start date cannot be more than end date!
									</p>
								</div>
							{/if}
						</Col>
						<Col xs={2}>
							<SveltyPicker
								inputClasses="form-control getgo input {$myForm.hasError(
									'activeTo.required'
								)
									? 'danger'
									: ''}"
								format="yyyy-mm-dd"
								placeholder="YYYY-MM-DD"
								bind:value={$activeTo.value}
							/>
							{#if $myForm.hasError("activeTo.required")}
								<div>
									<p class="error-text">
										End date is required
									</p>
								</div>
							{/if}
						</Col>
					</Row>
				</Col>

				{#if $vehicleModelId.value !== "" && $vehicleMakeId.value !== ""}
					<Col>
						<Row>
							<Col>
								<label for="fuelCapacity" class="d-block mt-3">
									<span>
										<b>Fuel (L)/Battery Capacity (kWh)</b
										></span
									>
								</label>
							</Col>
						</Row>
						<Row>
							<Col xs={6}>
								<CustomInput
									type="number"
									bind:value={$fuelCapacity.value}
									validate={required()}
									error={$vehicleModelId.value &&
										!$fuelCapacity.value}
									errorText="This field is empty, please add this
											data via Master Data > Vehicle
											Master Data > Car Efficiency"
									placeholder={$fuelCapacity.value === null
										? "No Data"
										: $fuelCapacity.value}
									onInput="validity.valid||(value='');"
									disabled
								/>
							</Col>
						</Row>
					</Col>
					<Col>
						<Row>
							<Col>
								<label
									for="fuelEfficiency"
									class="d-block mt-3"
								>
									<span>
										<b>Fuel/Battery Efficiency (km)</b
										></span
									>
								</label>
							</Col>
						</Row>
						<Row>
							<Col xs={6}>
								<CustomInput
									type="number"
									bind:value={$fuelEfficiency.value}
									validate={required()}
									error={$vehicleModelId.value &&
										!$fuelEfficiency.value}
									errorText="This field is empty, please add this
											data via Master Data > Vehicle
											Master Data > Car Efficiency"
									placeholder={$fuelEfficiency.value === null
										? "No Data"
										: $fuelEfficiency.value}
									onInput="validity.valid||(value='');"
									disabled
								/>
							</Col>
						</Row>
					</Col>
				{/if}
				<Col>
					<Row>
						<Col>
							<label for="currentMileage" class="d-block mt-3">
								<span> <b>Current Mileage</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomInput
								type="number"
								bind:value={$currentMileage.value}
								min="0"
								onInput="validity.valid||(value='');"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="currentFuel" class="d-block mt-3">
								<span> <b>Current Fuel Level</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomInput
								type="number"
								bind:value={$currentFuelLevel.value}
								min="0"
								step="1"
								onInput="validity.valid||(value='');"
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col>
							<label for="lastServiced" class="d-block mt-3">
								<span> <b>Last Serviced Mileage</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<CustomInput
								type="number"
								bind:value={$lastServiceMileage.value}
								error={$myForm.hasError(
									"lastServiceMileage.min"
								)}
								errorText={$myForm.hasError(
									"lastServiceMileage.min"
								)
									? "Input should only be a positive number"
									: ""}
							/>
						</Col>
					</Row>
				</Col>
				<Col>
					<Row>
						<Col xs={2}>
							<label for="lastServicedate" class="d-block mt-3">
								<span> <b>Last Serviced Date</b> </span>
							</label>
						</Col>
					</Row>
					<Row>
						<Col xs={2}>
							<SveltyPicker
								inputClasses="form-control getgo input {new Date(
									$lastServiceDate.value
								) > new Date()
									? 'border border-danger'
									: ''}"
								format="yyyy-mm-dd"
								placeholder="YYYY-MM-DD"
								bind:value={$lastServiceDate.value}
							/>
							{#if new Date($lastServiceDate.value) > new Date()}
								<div>
									<p class="error-text">
										Last service date cannot be in the
										future
									</p>
								</div>
							{/if}
						</Col>
					</Row>
				</Col>
				<Row>
					<Col class="d-flex justify-content-end gap-3">
						<Button class="themeButton" on:click={myForm.reset}
							>Reset</Button
						>
						<span
							class="d-inline-block"
							data-bs-toggle={!$myForm.valid ? "tooltip" : ""}
							title={!$myForm.valid
								? "Fill all required field"
								: ""}
						>
							<Button
								class="themeButton primary"
								disabled={new Date($lastCleanedDate.value) >
									new Date() ||
									new Date($lastServiceDate.value) >
										new Date() ||
									isInvalid}
								type="submit"
								on:click={handleSubmit}
								on:click={myForm.validate}
							>
								{#if load}
									<Loader />
								{:else if isEdit}
									Update
								{:else}
									Create
								{/if}
							</Button>
						</span>
					</Col>
				</Row>
			</div>
		</Col>
	</Row>
</LoaderContainer>

<WarningModal createCarError={true} />
